<template>
  <router-link
    :to="to"
    class="relative text-gpx_black-500 hover:text-gpx_terracotta-300"
  >
    <slot />
  </router-link>
</template>

<script setup>
defineProps({
  to: {
    type: [Object, String],
    required: true,
  },
});
</script>

<style scoped>
a.router-link-active {
  @apply text-gpx_terracotta-300 after:w-full after:h-px after:bg-gpx_terracotta-700 after:hidden md:after:block after:absolute after:bottom-0 after:left-0;
}
</style>
